import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A ticket reference that opens the ticket.
 *
 * Work & time, Billing and Issued Bills each printed the ticket number as
 * plain text, so a contractor looking at a line on an invoice had no way to
 * see what the job actually was - they had to remember the number, go to their
 * ticket list and find it. Gordon: there is no functionality to see the ticket
 * itself, create links.
 *
 * One component rather than three, because the destination differs by who is
 * looking - a contractor goes to their own page, staff to the staff one - and
 * three copies of that rule is three places for it to drift.
 */
export default function TicketLink({ id, children, className }) {
  const label = children || 'Ticket';
  // Without an id there is nothing to link to. Printing the number as plain
  // text is right then; a link that goes nowhere is worse than no link.
  if (!id) return <span className={className}>{label}</span>;
  const contractor = Boolean(localStorage.getItem('contractor_token'));
  return (
    <Link className={className} to={`${contractor ? '/my-tickets' : '/tickets'}/${id}`}>
      {label}
    </Link>
  );
}
